// Styles for EventProfileSkeletonLoader go here.
import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledEventProfileSkeletonLoader = styled.div`
  padding: ${toRem(24)} 0;
  .skeleton-loader {
    transition: height 0.3s ease, opacity 0.3s ease;
    border-radius: ${toRem(5)};
  }
`;

export const InputPlaceLoader = styled.div<{ width?: string }>`
  width: ${({ width }) => width || '80%'} !important;
  height: ${toRem(45)};
  margin-bottom: ${toRem(2)};
`;

export const TextPlaceLoader = styled.div<{ width?: string }>`
  width: ${({ width }) => width || '80%'} !important;
  height: ${toRem(20)};
  margin-bottom: ${toRem(2)};
`;
